import React from'react';
import classes from './index.css';
import TransitionExpand from "./TransitionExpand.js";
import WorkroleDetails from './WorkroleDetails';
export default function WorkroleBody(props){
    console.log('workrole body props');
    console.log(props);
    var workroles = props.workroles;
    return(
        <div className={classes.fullwidth}>
            <h2>Workroles</h2>
            <div className={classes.buttonRow}>
                {Object.keys(workroles).map((workroleId, id) => {
                    var workrole = workroles[workroleId]
                    var wrkroleClass = workrole.hidden ? classes.btnNotPressed : classes.btnPressed;
                    return(
                        <div className={classes.btnLvl2 + ' ' + wrkroleClass}
                            onClick={() => props.toggleHide(workrole.id)}
                            key={id}>
                            <h3>{workrole.name}</h3>
                        </div>
                    );
                })}
            </div>
            <div className={classes.workroleContent}>

                {Object.keys(workroles).map((workroleId, id) => {

                    var workrole = workroles[workroleId]
                    
                    return(
                        <TransitionExpand
                            key={id}
                            duration={500} height={!workrole.hidden ? 'auto' : 0}
                        >{!workrole.hidden && 
                            <WorkroleDetails
                                className={classes.fullwidth + ' ' + classes.workrolesBox}
                                wr={workrole.workrole}
                                comps={workrole.competencies}
                                courses={props.courses}
                                competencies={props.competencies}
                                certs={workrole.certifications}
                                allcerts={props.allcerts}
                                currWorkrole={workrole}
                                parentSaved={props.savedChildData ? props.savedChildData[workrole.id] : null}
                                //@save-please="saveChildData($event, workrole.id)" //unsure what this is about
                            />
                        }
                        </TransitionExpand>
                    )
                })}
            
            </div>
        </div>
    );
    /*
    return(
        <div>
        <h2>Workroles</h2>
        <div className={classes.buttonRow}>
            <div
                v-for="workrole in workroles"
                v-bind:key="`btm-${workrole.id}`"
                class='btn-lvl2'
                :class="{'btn-not-pressed': workrole.hidden, 'btn-pressed': !workrole.hidden}"
                @click="$emit('toggle-hide', workrole.id)"
            >

                <h3
                    v-if="Object.keys(workroles).length > 1"
                    title="Ctrl + Click to deselect other workrole."
                > {{workrole.name}} </h3>
            </div>
        </div>
        <div class="workrole-content">
            <TransitionExpand
                v-for="workrole in workroles"
                :key="`btm-${workrole.id}`"
            >
                <WorkroleDetails
                    v-if=" !workrole.hidden"
                    class="fullwidth workroles-box"
                    :wr="workrole.workrole"
                    :comps="workrole.competencies"
                    :courses="courses"
                    :competencies="competencies"
                    :certs="workrole.certifications"
                    :allcerts="allcerts"
                    :parentSaved="savedChildData[workrole.id]"
                    @save-please="saveChildData($event, workrole.id)"
                />
        </TransitionExpand>
        </div>
        <div
            v-for="workrole in workroles"
            v-bind:key="workrole.id"
        >
        </div>
    </div> 
    )
    */
}